/* Europe Mark – Shopify Cart AJAX discounts (May 2025+). */
(() => {
  'use strict';
  if (window.EuropeMarkCartDiscountV1) return;
  window.EuropeMarkCartDiscountV1 = true;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const feedback = (form, message, ok) => {
    const note = form && form.querySelector('.em-cart-discount-feedback');
    if (!note) return;
    note.textContent = message;
    note.hidden = !message;
    note.dataset.status = ok ? 'success' : 'error';
  };

  const readResponse = async (response) => {
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.description || payload.message || 'Could not apply this discount code.');
    return payload;
  };

  const replaceRenderedSection = (markup, findSelector, replaceSelector, preserveHost) => {
    if (!markup) return false;
    const nextDoc = new DOMParser().parseFromString(markup, 'text/html');
    const next = nextDoc.querySelector(findSelector);
    const current = document.querySelector(replaceSelector);
    if (!next || !current) return false;
    if (preserveHost) {
      current.innerHTML = next.innerHTML;
    } else {
      current.replaceWith(next);
    }
    return true;
  };

  const updateVisibleCart = (result, isDrawer) => {
    const sections = result.sections || {};
    let didUpdate = false;
    if (isDrawer) {
      // Preserve the active cart-drawer custom element and overlay listener.
      didUpdate = replaceRenderedSection(sections['cart-drawer'], '#CartDrawer .drawer__inner', 'cart-drawer #CartDrawer .drawer__inner', true);
      const drawer = document.querySelector('cart-drawer');
      if (drawer && didUpdate) drawer.classList.add('active');
    } else {
      didUpdate = replaceRenderedSection(sections['cart-footer'], '#main-cart-footer', '#main-cart-footer', true);
    }
    replaceRenderedSection(sections['cart-icon-bubble'], '#cart-icon-bubble', '#cart-icon-bubble', true);
    return didUpdate;
  };

  const evaluate = (cart, code) => {
    const codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
    const found = codes.find(entry => String(entry.code || entry).toLowerCase() === code.toLowerCase());
    if (found && found.applicable === false) return { message: 'This discount code is not eligible for your cart.', ok: false };
    if (found && found.applicable === true) return { message: 'Discount applied to your cart.', ok: true };
    const applications = Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : [];
    const matched = applications.some(d => String(d.title || '').toLowerCase() === code.toLowerCase());
    if (matched) return { message: 'Discount applied to your cart.', ok: true };
    return { message: 'Code submitted. Eligible savings will appear in the cart or at checkout.', ok: true };
  };

  document.addEventListener('input', event => {
    if (event.target && event.target.matches('.em-cart-discount-input')) {
      feedback(event.target.closest('form.em-cart-discount-form'), '', false);
    }
  });

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.em-cart-discount-form')) return;
    event.preventDefault();
    const input = form.querySelector('.em-cart-discount-input');
    const submit = form.querySelector('.em-cart-discount-apply');
    if (!input || !submit || submit.disabled) return;
    const code = input.value.trim();
    if (!code) {
      feedback(form, 'Please enter a discount code.', false);
      input.focus();
      return;
    }

    const inDrawer = Boolean(form.closest('cart-drawer'));
    const oldLabel = submit.textContent;
    submit.disabled = true;
    submit.textContent = 'Applying…';
    feedback(form, '', false);

    try {
      const resp = await fetch(root() + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          discount: code,
          sections: ['cart-drawer', 'cart-footer', 'cart-icon-bubble'],
          sections_url: root() + 'cart'
        })
      });
      const cart = await readResponse(resp);
      const result = evaluate(cart, code);
      const rendered = updateVisibleCart(cart, inDrawer);
      if (rendered) {
        const selector = inDrawer ? 'cart-drawer .em-cart-discount-form' : 'body[data-page-type="cart"] #MainContent .em-cart-discount-form';
        const replacementForm = document.querySelector(selector);
        if (replacementForm) feedback(replacementForm, result.message, result.ok);
      } else {
        // A full page refresh is safer than leaving stale totals in a cart.
        try { if (inDrawer) sessionStorage.setItem('em-halloween-reopen-cart', '1'); } catch (_) {}
        window.location.reload();
        return;
      }
    } catch (error) {
      feedback(form, error.message || 'Could not apply this discount code. Please try again.', false);
    } finally {
      if (submit.isConnected) {
        submit.disabled = false;
        submit.textContent = oldLabel;
      }
    }
  });

  const reopenIfRequested = () => {
    let reopen = false;
    try {
      reopen = sessionStorage.getItem('em-halloween-reopen-cart') === '1';
      sessionStorage.removeItem('em-halloween-reopen-cart');
    } catch (_) {}
    if (!reopen) return;
    const doOpen = () => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    };
    if (window.customElements && customElements.get('cart-drawer')) doOpen();
    else if (window.customElements) customElements.whenDefined('cart-drawer').then(doOpen);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reopenIfRequested, { once:true });
  else reopenIfRequested();
})();
